var map = {
	"./logo-chat-sm.svg": 24315,
	"./promo.svg": 45659,
	"./site-logo-desktop-footer.svg": 37662,
	"./site-logo-desktop.svg": 31990,
	"./site-logo-drawer-mobile.svg": 23692,
	"./site-logo-drawer.svg": 59409,
	"./site-logo-mobile-drawer.svg": 21494,
	"./site-logo-mobile.svg": 28108,
	"./site-logo-sm.svg": 13902,
	"./site-logo-tv.svg": 56884,
	"./site-logo-wrapper-mobile-scrolled.svg": 25335,
	"./site-logo-wrapper-mobile.svg": 22374,
	"./site-logo-wrapper-scrolled.svg": 36664,
	"./site-logo-wrapper.svg": 76823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94941;